import { useTheme } from '@nivo/core';
import { ResponsiveFunnel } from '@nivo/funnel';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { formatPeopleCount } from '~/utils/helpers';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { FunnelChartBlock } from './blockTypes';

interface Props {
  block: FunnelChartBlock;
}

const PADDING_X = 32;

const Parts = (props: any) => {
  const theme = useContext(ThemeContext);
  return props.parts.map((part: any, index: number) => {
    const x = part.x as number;
    const y = part.y as number;
    const width = part.width as number;
    const height = part.height as number;
    const separatorWidth = props.width - PADDING_X;

    return (
      <g key={part.data.id} transform={`translate(${x}, ${y})`}>
        <rect
          x={-width / 2}
          y={-height / 2}
          width={width}
          height={height}
          fill={part.color}
          onMouseDown={(e) => part.onMouseDown(e)}
          onMouseMove={(e) => part.onMouseMove(e)}
          onMouseLeave={(e) => part.onMouseLeave(e)}
        />
        {index === 0 && (
          <rect x={-x - PADDING_X / 2} y={-y - 4} width={separatorWidth} height={1} fill={theme.colors.neutrals.c050} />
        )}
        <rect
          x={-x - PADDING_X / 2}
          y={height / 2 + 4}
          width={separatorWidth}
          height={1}
          fill={theme.colors.neutrals.c050}
        />
      </g>
    );
  });
};

const Labels = (props: any) => {
  const theme = useContext(ThemeContext);
  return props.parts.map((part: any) => {
    if ((part.width as number) < 20) return null;
    return (
      <g key={part.data.id} transform={`translate(${part.x as number}, ${part.y as number})`}>
        <text
          textAnchor="middle"
          dominantBaseline="central"
          fill={theme.colors.neutrals.white}
          fontSize={11}
          fontWeight={600}
          pointerEvents="none"
        >
          {formatPeopleCount(part.data.value as number)}
        </text>
      </g>
    );
  });
};

const SideLabels = (props: any) => {
  const nivoTheme = useTheme();
  return props.parts.map((part: any) => (
    <g key={part.data.id} transform={`translate(0, ${part.y as number})`}>
      <text dominantBaseline="central" style={nivoTheme.labels.text}>
        {part.data.label as string}
      </text>
    </g>
  ));
};

const SimpleFunnelChart = ({ block }: Props) => {
  const theme = useContext(ThemeContext);

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper $height={280}>
        <ResponsiveFunnel
          data={block.data}
          margin={{ top: 8, right: PADDING_X, bottom: 32, left: PADDING_X }}
          beforeSeparatorOffset={64}
          afterSeparatorOffset={64}
          valueFormat={(value: number) => formatPeopleCount(value)}
          spacing={8}
          colors={theme.colors.graph[3]}
          layers={[Parts, Labels, 'annotations', SideLabels]}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleFunnelChart;
